import { cloneDeep } from 'lodash';

const formatTimestamp = (timestamp) => {
  const date = new Date(timestamp*1000);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

const mergeRealmData= (entList, aloneOrgList) => {
  let resultAry = []
  
  let enterprisesList = []
  if(entList.data && entList.data.length > 0){
    enterprisesList = entList.data
  }
  let standAloneList = []
  if(aloneOrgList.data && aloneOrgList.data.length > 0){
    standAloneList = aloneOrgList.data
  }

  for(let childEnt of enterprisesList){
    let child = {
      id: childEnt.entId,
      name: childEnt.entName,
      hasManageOrg: true,
      roleId: childEnt.entRoleId,
      roleName: childEnt.entRoleName,
      createdAt: childEnt.createdAt,
      createdTime: formatTimestamp(childEnt.createdAt),
      enableAction: (childEnt.entRoleId === 1 || childEnt.entRoleId === 2)? true:false
    }
    resultAry.push(child)
  }
  for(let childAloneOrg of standAloneList){
    let child = {
      id: childAloneOrg.orgId,
      name: childAloneOrg.orgName,
      hasManageOrg: false,
      roleId: childAloneOrg.orgRoleId,
      roleName: childAloneOrg.orgRoleName,
      createdAt: childAloneOrg.createdAt,
      createdTime: formatTimestamp(childAloneOrg.createdAt),
      enableAction: (childAloneOrg.orgRoleId === 5 || childAloneOrg.orgRoleId === 6)? true:false
    }
    resultAry.push(child)
  }
  
  return resultAry;
}

const mergeOrgData= (orgList) => {
  let resultAry = []
  
  let manageOrgList = []
  if(orgList.data && orgList.data.orgs.length > 0){
    manageOrgList = orgList.data.orgs
  }

  for(let childEnt of manageOrgList){
    let child = {
      id: childEnt.orgId,
      name: childEnt.orgName,
      roleId: childEnt.orgRoleId,
      roleName: childEnt.orgRoleName,
    }
    resultAry.push(child)
  }
  
  return resultAry;
}

const mergeSiteData= (siteList) => {
  let resultAry = []
  
  let orgSiteList = []
  if(siteList.data && siteList.data.sites.length > 0){
    orgSiteList = siteList.data.sites
  }

  for(let childEnt of orgSiteList){
    let child = {
      id: childEnt.siteId,
      name: childEnt.siteName,
      roleId: childEnt.siteRoleId,
      roleName: childEnt.siteRoleName,
    }
    resultAry.push(child)
  }
  
  return resultAry;
}

export default {
  mergeRealmData,
  mergeOrgData,
  mergeSiteData
};
